module.exports = __webpack_public_path__ + "f2b6e66c0f54185ec87d4d32d1e54032.svg";